import { render, staticRenderFns } from "./user_management.vue?vue&type=template&id=19bac5b8&scoped=true&"
import script from "./user_management.vue?vue&type=script&lang=js&"
export * from "./user_management.vue?vue&type=script&lang=js&"
import style0 from "./user_management.vue?vue&type=style&index=0&id=19bac5b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bac5b8",
  null
  
)

export default component.exports